// extracted by mini-css-extract-plugin
export default {"container":"success_container__OzDDo","success":"success_success__R84yZ","success__card":"success_success__card__aGSlQ","success__icon":"success_success__icon__s1+f8"};